import * as React from "react";

import "./shipping-split.scss";

import {cs}           from "@Common/react/chain-services";
import {DataTableD}   from "@Common/ui-components/heavy/common/design2/data-table/desktop/data-table-d";
import {formatMoney}  from "@Common/ui-components/language/format-money";
import {isSuperSmall} from "@Common/utils/math/is-super-small";

import {SubsxFree}             from "../../../../../common/subsx-free/subsx-free";
import {isFreightServiceLevel} from "../common/is-freight-service-level";

import {AddressCol}      from "./address-col/address-col";
import {ServiceLevelCol} from "./service-level-col/service-level-col";

export const ShippingSplit = ({addressData: {myAddresses, officeAddress}, store, apiError, next: rootNext}) => cs(
    ["addressCol", (_, next) => AddressCol({
        myAddresses, officeAddress,
        store, apiError,
        next,
    })],
    ["serviceLevelCol", (_, next) => ServiceLevelCol({store, apiError, next})],
    ({addressCol, serviceLevelCol}) => rootNext({
        invalid: store.cart.items.find((item) => addressCol.isInvalid(item)),
        render: () => (
            <div className="shipping-split-0ui">
                <div className="header" xd-qa-type="label" xd-qa-name="Separate Shipping">
                    Select Separate Shipping Options
                </div>

                {DataTableD({
                    rows: store.cart.items.filter((i) => i.selections.distributionType === "shipping").map((item) => ({
                        key: item.itemId,
                        columns: [
                            {
                                render: () => ItemSummary({
                                    item,
                                }),
                            },
                            {
                                render: () => addressCol.render({item}),
                            },
                            {
                                render: () => serviceLevelCol.render({item}),
                            },
                            {
                                render: () => (
                                    !item.selections?.mailingListIds?.some((m) => !isSuperSmall(+(m.unitPrice ?? 0))) && item.selections?.mailingListIds?.some((m) => m.hasSubscriptionBenefit) ? (
                                        SubsxFree({
                                            xdQaName: 'Subsx Shipping Charge '+item.itemId
                                        })
                                    ) : isSuperSmall(+(item.shipping?.shippingCharge ?? 0)) && item.shipping?.hasSubscriptionBenefit ? (
                                        SubsxFree({
                                            xdQaName: 'Subsx Shipping Charge '+item.itemId
                                        })
                                    ) : (
                                        <div className="money-value" xd-qa-type="label" xd-qa-name={`Shipping Charge ${item.itemId}`}>
                                            {!isFreightServiceLevel(item.shipping?.serviceLevel) && (
                                                item.shipping?.shippingCharge && formatMoney(+(item.shipping.shippingCharge ?? 0))
                                            )}
                                        </div>
                                    )
                                )
                            }
                        ],
                    })),
                    columns: [
                        {
                            label: "ITEM",
                            width: "1%",
                            align: "left",
                            domAttrs: {
                                "xd-qa-type": "label",
                                "xd-qa-name": "Item"
                            }
                        },
                        {
                            label: "SHIPPING ADDRESS",
                            align: "left",
                            domAttrs: {
                                "xd-qa-type": "label",
                                "xd-qa-name": "Shipping Address"
                            }
                        },
                        {
                            label: "SERVICE LEVEL",
                            align: "left",
                            domAttrs: {
                                "xd-qa-type": "label",
                                "xd-qa-name": "Service Level"
                            }
                        },
                        {
                            label: "COST",
                            align: "right",
                            className: "cost",
                            domAttrs: {
                                "xd-qa-type": "label",
                                "xd-qa-name": "Cost"
                            }
                        },
                    ],
                })}
            </div>
        )
    }),
);



const ItemSummary = ({item}) => (
    <div className="item-summary">
        <div className="thumbnail">
            <div
                className="image"
                style={{backgroundImage: `url('${item.itemThumbnails?.[0]}')`}}
                xd-qa-type="image"
                xd-qa-name={`Thumbnail ${item.itemId}`}
            />
        </div>

        <div className="details">
            <div className="name" xd-qa-type="label" xd-qa-name={`Shipping Item Name ${item.itemId}`}>
                {item.metaData?.productName || item.itemName || "Brochure"}
            </div>
        </div>
    </div>
);
